import { clearCacheData } from "./Utils";
import ssoConfigUrls from "../configs/UrlContants";

const CLIENT_ID = ssoConfigUrls.ssoClientId;
const ISSUER = ssoConfigUrls.ssoIssuer;

const REDIRECT_URI = window.location.origin + "/implicit/callback";
const REDIRECT_URI_EXTERNAL = window.location.origin + "/callback";
const POST_REDIRECT_URI = window.location.origin + "/";
const EXTERNAL_CLIENT_ID = "0oa2uxmr9r5ic6sIQ0h8";
const EXTERNAL_ISSUER = "https://pepsico.oktapreview.com/oauth2/default";

// eslint-disable-next-line
export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: POST_REDIRECT_URI,
    scopes: ["openid", "pepappmcoeroles", "email", "profile"],
    responseType: "code",
    pkce: true,
    tokenManager: {
      autoRenew: true,
      storage: "sessionStorage",
    },
    onSessionExpired: function () {
      clearCacheData();
      window.location.assign("/");
    },
  },
  externalOidc: {
    clientId: EXTERNAL_CLIENT_ID,
    issuer: EXTERNAL_ISSUER,
    redirectUri: REDIRECT_URI_EXTERNAL,
    postLogoutRedirectUri: POST_REDIRECT_URI,
    scopes: ["openid", "email", "profile", "offline_access"],
    responseType: "code",
    pkce: true,
    tokenManager: {
      autoRenew: true,
      storage: "sessionStorage",
    },
  },
};
